import './ProjectAmenities.css';

export default function ProjectAmenities({ project }) {
  const { amenities, lift } = project;
  if (!amenities || !amenities.length) return null;

  return (
    <section className="pd-section pd-amenities">
      <p className="pd-eyebrow">Features &amp; Amenities</p>
      <h2 className="pd-title">Everything <em>included</em></h2>

      <ul className="pd-amenities__grid">
        {amenities.map((a) => (
          <li key={a.name} className="pd-amenity">
            <span className="pd-amenity__icon" aria-hidden="true">{a.icon}</span>
            <span className="pd-amenity__name">{a.name}</span>
          </li>
        ))}
      </ul>

      {lift?.show && lift.note && (
        <p className="pd-amenities__note">{lift.note}</p>
      )}
    </section>
  );
}
